import { useEffect, useState } from 'react';

import { api } from './api';
import type { ShopSettings } from './api';

/**
 * Настройки магазина — минимальная сумма и тарифы доставки.
 *
 * Берём с сервера, а не держим копию в витрине: тариф меняется в одном месте
 * и сразу виден и на сайте, и в расчёте заказа. Запрос один на визит —
 * результат запоминается, и шапка, корзина и оформление берут его оттуда.
 */

let cached: ShopSettings | null = null;
let pending: Promise<ShopSettings> | null = null;

export function useSettings(): ShopSettings | null {
  const [settings, setSettings] = useState<ShopSettings | null>(cached);

  useEffect(() => {
    if (cached) return;
    pending ??= api.settings('ru').then((s) => {
      cached = s;
      return s;
    });
    pending.then(setSettings).catch(() => {
      // Без настроек сайт работает: сервер всё равно проверит минимум при
      // оформлении. Просто не покажем подсказку заранее
      pending = null;
    });
  }, []);

  return settings;
}
